// src/utils/incidentHandlers.ts
import { NavigateFunction, useNavigate } from "react-router-dom";
import config from "../../config";
import { IncidentData } from "./incidentTypes";
import logo from "../../Assets/j.png";
import ses from "../../Assets/ses.jpg";
import { authFetch } from "../Security/authFetch";
import { useState } from "react";
import { getSignatureLines } from "../emailSignature";
const email = localStorage.getItem("email");
const recipients = ["g.kattan@bcomsat.com"];

const isallsite = localStorage.getItem("isAllSite");
const isallnetwork = localStorage.getItem("isAllNetwork");
const isalllink = localStorage.getItem("isAllLink");

const isAdmin = localStorage.getItem("isAdmin") === "true";
const postMessage = async (payload: any) => {
  return authFetch(`${config.apiBaseUrl}/api/messages`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });
};
// Petrobras incidents: customer-informed emails go only to these recipients
export const PETROBRAS_EMAILS = [
  "gabriel.azevedo@petrobras.com.br",
  "bernardo.pimenta@petrobras.com.br",
  "marcelo.fiuza@ses.com",
];
export const isPetrobrasCustomer = (affectedCustomer: unknown): boolean =>
    String(affectedCustomer ?? "").toLowerCase().includes("petrobras");

// Vodacom Mozambique / South Africa incidents: these recipients get every "opened" email
export const VODACOM_SOUTHERN_AFRICA_EMAILS = ["Rudolph.Cloete@ses.com"];
export const isVodacomSouthernAfricaCustomer = (affectedCustomer: unknown): boolean => {
  const c = String(affectedCustomer ?? "").toLowerCase();
  return c.includes("Vodacom mozambique") || c.includes("Vodacom south Africa");
};

const fetchcustomerEmails = async (data: IncidentData): Promise<string[]> => {
  if (isPetrobrasCustomer(data.affectedCustomer)) return PETROBRAS_EMAILS;
  const responseEmails = await authFetch(
      `${config.apiBaseUrl}/api/users/email-by-id?id=${data.foruserid}`
  );
  if (!responseEmails.ok)
    throw new Error(`HTTP error! status: ${responseEmails.status}`);

  const emails = await responseEmails.json();

  return emails;
};
const fetchEmailsWithRole2 = async (): Promise<string[]> => {
  try {
    const response = await authFetch(
        `${config.apiBaseUrl}/api/responsible-person/emails/role2`
    );
    if (!response.ok) {
      throw new Error("Failed to fetch emails");
    }
    const data = await response.json();

    const allEmails = [...data];
    const uniqueEmails = Array.from(new Set(allEmails));
    return uniqueEmails;
  } catch (err: any) {
    console.error("Email fetch failed:", err);
    return [];
  }
};
export const handleEdit = async (
    data: IncidentData,
    navigate: NavigateFunction,
    fetchMessages: () => void,
    changedFields: string[] = []
) => {
  const username = localStorage.getItem("username") || "System";
  const isAdmin = localStorage.getItem("isAdmin") === "true";

  // ✅ Message details (fields edited)
  const details =
      changedFields.length > 0
          ? changedFields
              .filter(Boolean)
              .map((f) => `Field ${f} has been edited by ${username}`)
              .join("\n")
          : `Incident With Id ${data.ticketId} Edited by ${username}.`;

  const payload = {
    username,
    message: details,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  // ✅ Save journal message
  try {
    const res = await postMessage(payload);
    if (res.ok) fetchMessages();
    else console.error("Failed to save message");
  } catch (e) {
    console.error("Error while saving message:", e);
  }

  // ✅ Email notification (only when NOT admin) + include edited fields
  if (!isAdmin) {
    try {
      const emails = await fetchEmailsWithRole2();

      const editedFieldsHtml =
          changedFields.length > 0
              ? `
            <p><strong>Edited Fields:</strong></p>
            <ul>
              ${changedFields.map((f) => `<li>${f}</li>`).join("")}
            </ul>
          `
              : "";

      await authFetch(`${config.apiBaseUrl}/api/email/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          to: emails,
          subject: `An Incident with ID ${data.ticketId} has been Edited.`,
          body: `
    <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
      <p>Hello,</p>

      <p>
        A ticket with ID <strong>${data.ticketId}</strong> has been edited by <strong>${username}</strong>.
      </p>

      ${editedFieldsHtml}

      <p>
      <strong>Customer:</strong> ${data.affectedCustomer ?? ""}<br><br>
      <strong>Network:</strong> ${data.affectedNetwork ?? ""}<br><br>
      <strong>Site:</strong> ${data.affectedSite ?? ""}<br><br>
      <strong>Link:</strong> ${data.affectedLink ?? ""}<br><br>

      <strong>Incident Start Date:</strong> ${
              data.incidentStartDatetime ? data.incidentStartDatetime.replace("T", " ") : ""
          }<br><br>

      <strong>Incident Close Date:</strong> ${
              data.incidentCloseDatetime ? data.incidentCloseDatetime.replace("T", " ") : ""
          }<br><br>

      <strong>Summary:</strong> ${data.summary ?? ""}<br><br>
      <strong>Description:</strong> ${data.description ?? ""}<br><br>
      <strong>Error Type:</strong> ${data.errorType ?? ""}<br><br>
      <strong>Closure Code:</strong> ${data.closureCode ?? ""}<br><br>
      <strong>Solution:</strong> ${data.solution ?? ""}</p>

      <p>Regards,<br><br></p>

      <a href="https://bdm.bcomsat.com" target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
        👉 View Incident Details
      </a>

      <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
        <tr>
          <td style="vertical-align: top; padding-right: 12px;">
            <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
          </td>

          <td>
            <div style="
              padding: 12px;
              border-left: 4px solid #2a1364;
              background-color: #f9f9f9;
              color: #2a1364;
              font-size: 13px;
            ">
              <strong>Managed Services Operations</strong><br>
              ${getSignatureLines(data.affectedCustomer, "#2a1364")}
            </div>
          </td>
        </tr>
      </table>
    </div>
  `,
        }),
      });
    } catch (emailErr) {
      console.error("Failed to send email notification:", emailErr);
    }
  }

  // ✅ Keep navigation as you had it
  navigate(`/incident-edit/${data.ticketId}`, { state: { incident: data } });
};


export const handleAccept = async (
    data: IncidentData,
    fetchMessages: () => void,
    onUpdate?: (updated: IncidentData) => void
) => {
  const isallsite = localStorage.getItem("isAllSite");
  const isallnetwork = localStorage.getItem("isAllNetwork");
  const isalllink = localStorage.getItem("isAllLink");
  const siteInfo = isallsite === "true" ? "All Sites" : data.affectedSite ?? "";
  const linkInfo = isalllink === "true" ? "All Links" : data.affectedLink ?? "";
  const networkInfo =
      isallnetwork === "true" ? "All Networks" : data.affectedNetwork ?? "";
  const username = localStorage.getItem("username") || "System";
  const payload = {
    username,
    message: `Incident With Id ${data.ticketId} Accepted.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    console.log(
        "infoooooooooooooooooooooooo",
        isalllink,
        isallsite,
        isallnetwork
    );
//     if (data.customerInformed) {
//       // alert(recipients);
//       const emails = await fetchcustomerEmails(data);

//       try {
//         await authFetch(`${config.apiBaseUrl}/api/email/send`, {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },

//           body: JSON.stringify({
//             to: emails,

//             subject: `An Incident with ID ${data.ticketId} has been put in progress.`,
//             body: `
//     <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
//       <p>Hello,</p>

//       <p>A ticket with ID  ${
//         data.ticketId
//       } has been put in progress with the following comment
// </p>

//       <p><strong>Customer:</strong> ${data.affectedCustomer ?? ""}<br><br>
//       <strong>Network:</strong> ${networkInfo ?? ""}<br><br>
//       <strong>Site:</strong> ${siteInfo ?? ""}<br><br>
//       <strong>Link:</strong> ${linkInfo ?? ""}<br><br>
// <strong>Incident Start Date:</strong> ${
//               data.incidentStartDatetime
//                 ? data.incidentStartDatetime.replace("T", " ")
//                 : ""
//             }<br><br>


// <strong>Incident Close Date:</strong> ${
//               data.incidentCloseDatetime
//                 ? data.incidentCloseDatetime.replace("T", " ")
//                 : ""
//             }<br><br>

//       <strong>Summary:</strong> ${data.summary ?? ""}<br><br>
//       <strong>Description:</strong> ${data.description ?? ""}<br><br>
//       <strong>Error Type:</strong> ${data.errorType ?? ""}<br><br>
//       <strong>Closure Code:</strong> ${data.closureCode ?? ""}<br><br>
//       <strong>Solution:</strong> ${data.solution ?? ""}</p>
//       <p>
//             <p>Regards,<br><br></p>

//    <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
//                 👉 View Incident Details
//               </a>
//     </p>

//    <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
//       <tr>
//         <td style="vertical-align: top; padding-right: 12px;">

//          <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />


//         </td>

//         <td>
//           <div style="
//             padding: 12px;
//             border-left: 4px solid #2a1364;
//             background-color: #f9f9f9;
//             color: #2a1364;
//             font-size: 13px;
//           ">
//             <strong>Managed Services Operations</strong><br>
//             Value-Added Service<br>
//             Tel. & Whatsapp msg: +41 225521085<br>
//             Email: <a href="mailto:support@bcomintelsat.com" style="color: #2a1364;">support@bcomintelsat.com</a>
//           </div>
//         </td>
//       </tr>
//     </table>
//     </div>
//   `,
//           }),
//         });
//       } catch (emailErr) {
//         console.error("Failed to send email notification:", emailErr);
//       }
//     } else if (!isAdmin) {
//       const emails = await fetchEmailsWithRole2();
//       try {
//         await authFetch(`${config.apiBaseUrl}/api/email/send`, {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },

//           body: JSON.stringify({
//             to: emails,
//             subject: `An Incident with ID ${data.ticketId} has been in progress`,
//             body: `
//           <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
//             <p>Hello,</p>
//             <p>A ticket with ID  ${
//               data.ticketId
//             } has been put in progress with the following comment</p>
//       <p><strong>Customer:</strong> ${data.affectedCustomer ?? ""}<br><br>
//       <strong>Network:</strong> ${networkInfo ?? ""}<br><br>
//       <strong>Site:</strong> ${siteInfo ?? ""}<br><br>
//       <strong>Link:</strong> ${linkInfo ?? ""}<br><br>
// <strong>Incident Start Date:</strong> ${
//               data.incidentStartDatetime
//                 ? data.incidentStartDatetime.replace("T", " ")
//                 : ""
//             }<br><br>


// <strong>Incident Close Date:</strong> ${
//               data.incidentCloseDatetime
//                 ? data.incidentCloseDatetime.replace("T", " ")
//                 : ""
//             }<br><br><br>

//       <strong>Summary:</strong> ${data.summary ?? ""}<br><br>
//       <strong>Description:</strong> ${data.description ?? ""}<br><br>
//       <strong>Error Type:</strong> ${data.errorType ?? ""}<br><br>
//       <strong>Closure Code:</strong> ${data.closureCode ?? ""}<br><br>
//       <strong>Solution:</strong> ${data.solution ?? ""}</p>
//             <p>
//                         <p>Regards,<br><br><br></p>

//     <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
//                 👉 View Incident Details
//               </a>
//     </p>
//          <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
//       <tr>
//         <td style="vertical-align: top; padding-right: 12px;">

//          <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />


//         </td>

//         <td>
//           <div style="
//             padding: 12px;
//             border-left: 4px solid #2a1364;
//             background-color: #f9f9f9;
//             color: #2a1364;
//             font-size: 13px;
//           ">
//             <strong>Managed Services Operations</strong><br>
//             Value-Added Service<br>
//             Tel. & Whatsapp msg: +41 225521085<br>
//             Email: <a href="mailto:support@bcomintelsat.com" style="color: #2a1364;">support@bcomintelsat.com</a>
//           </div>
//         </td>
//       </tr>
//     </table>
//           </div>
//         `,
//           }),
//         });

//         alert("Email sent: Customer was NOT informed.");
//       } catch (emailErr) {
//         console.error("Failed to send fallback email notification:", emailErr);
//       }
//     }
    const msgRes = await postMessage(payload);
    const updRes = await authFetch(
        `${config.apiBaseUrl}/api/incidents/${data.ticketId}/accept`,
        { method: "PUT" }
    );

    if (msgRes.ok && updRes.ok) {
      fetchMessages();
      const res = await authFetch(
          `${config.apiBaseUrl}/api/incidents/${data.ticketId}`
      );
      if (res.ok) {
        const updated = await res.json();
        if (onUpdate) onUpdate(updated);
      }
    } else {
      console.error("Failed to accept or save message");
    }
  } catch (e) {
    console.error("Error while accepting incident:", e);
  }
};
export const handleClose = async (
    data: IncidentData,
    fetchMessages: () => void
) => {
  alert(1);
  const emails = await fetchcustomerEmails(data);

  const username = localStorage.getItem("username") || "System";
  const emailBody = `
    <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
      <p>Hello,</p>
      <p>This Ticket was Closed with the following comment:</p>
      <p>
        <strong>Customer:</strong> ${data.affectedCustomer ?? ""}<br><br>
   
      <strong>Network:</strong> ${data.affectedNetwork ?? ""}<br><br>
      <strong>Site:</strong> ${data.affectedSite ?? ""}<br><br>
      <strong>Link:</strong> ${data.affectedLink ?? ""}<br><br>
        <strong>Incident Start Date:</strong> ${
      data.incidentStartDatetime?.replace("T", " ") ?? ""
  }<br><br>
        <strong>Incident Close Date:</strong> ${
      data.incidentCloseDatetime?.replace("T", " ") ?? ""
  }<br><br>
        <strong>Summary:</strong> ${data.summary ?? ""}<br><br>
        <strong>Description:</strong> ${data.description ?? ""}<br><br>
        <strong>Error Type:</strong> ${data.errorType ?? ""}<br><br>
        <strong>Closure Code:</strong> ${data.closureCode ?? ""}<br><br>
        <strong>Solution:</strong> ${data.solution ?? ""}<br><br>
      </p>
      <p>
            <p>Regards,<br><br></p>

  <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View Incident Details
              </a>
    </p>
   <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(data.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
    </div>
  `;

  const payload = {
    username,
    message:
        `Incident With Id ${data.ticketId} Closed.\n` +
        `Closure Code: ${data.closureCode}\n` +
        `Error Type: ${data.errorType}\n` +
        `Solution: ${data.solution}\n` +
        `Category: ${data.category}`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };
  try {
    try {
      const msgRes = await postMessage(payload);
    } catch (err) {
      console.error("Failed to post message:", err);
    }
    const updRes = await authFetch(
        `${config.apiBaseUrl}/api/incidents/${data.ticketId}/close`,
        {
          method: "PUT",
        }
    );

    if (updRes.ok) {
      fetchMessages();
      window.location.reload();
    } else {
      console.error("Failed to close the incident.");
    }
  } catch (err) {
    console.error("Error closing incident:", err);
  }
  try {
    if (data.customerInformed) {
      await authFetch(`${config.apiBaseUrl}/api/email/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          to: emails,
          subject: `An Incident with ID ${data.ticketId} has been Closed`,
          body: emailBody,
        }),
      });
      //console.log("Customer informed email sent.");
    } else if (!isAdmin) {
      const emails = await fetchEmailsWithRole2();
      await authFetch(`${config.apiBaseUrl}/api/email/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          to: emails,
          subject: `An Incident with ID ${data.ticketId} has been Closed`,
          body: emailBody,
        }),
      });
      //console.log("Fallback email sent to role 2 users.");
    }
  } catch (e) {
    console.error("Error sending email:", e);
  }
};
export const handlePause = async (
    data: IncidentData,
    fetchMessages: () => void,
    onUpdate?: (updated: IncidentData) => void
) => {
  const comment = localStorage.getItem("comment") || "System";
  const username = localStorage.getItem("username") || "System";

  const payload = {
    username,
    message: `Incident With Id ${data.ticketId} Paused.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    //const msgRes = await postMessage(payload);
    const updRes = await authFetch(
        `${config.apiBaseUrl}/api/incidents/${data.ticketId}/pause`,
        { method: "PUT" }
    );

    if ( updRes.ok) {
      fetchMessages(); // refresh messages

      let updated: IncidentData;

      try {
        // try parsing response if any
        const text = await updRes.text();
        if (text) {
          updated = JSON.parse(text);
        } else {
          // fallback: fetch latest incident from backend
          const res = await fetch(
              `${config.apiBaseUrl}/api/incidents/${data.ticketId}`,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                },
              }
          );
          updated = await res.json();
        }
      } catch (err) {
        console.error("Failed to get updated incident:", err);
        updated = data; // last resort fallback
      }

      onUpdate?.(updated); // update parent grid
    } else {
      console.error("Failed to pause or save message");
    }
  } catch (e) {
    console.error("Error while pausing incident:", e);
  }
  if (data.customerInformed) {
    const emails = await fetchcustomerEmails(data);

    try {
      await authFetch(`${config.apiBaseUrl}/api/email/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },

        body: JSON.stringify({
          to: emails,
          subject: `An Incident with ID ${data.ticketId} has been Put on hold`,
          body: `
    <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
      <p>Hello,</p>

      <p>A ticket with ID ${
              data.ticketId
          } has been put on hold with the following comment
</p>

      <p><strong>Customer:</strong> ${data.affectedCustomer ?? ""}<br><br>

      <strong>Network:</strong> ${data.affectedNetwork ?? ""}<br><br>
      <strong>Site:</strong> ${data.affectedSite ?? ""}<br><br>
      <strong>Link:</strong> ${data.affectedLink ?? ""}<br><br>
<strong>Incident Start Date:</strong> ${
              data.incidentStartDatetime
                  ? data.incidentStartDatetime.replace("T", " ")
                  : ""
          }<br><br>


<strong>Incident Close Date:</strong> ${
              data.incidentCloseDatetime
                  ? data.incidentCloseDatetime.replace("T", " ")
                  : ""
          }<br><br>

      <strong>Summary:</strong> ${data.summary ?? ""}<br><br>
      <strong>Description:</strong> ${data.description ?? ""}<br><br>
      <strong>Error Type:</strong> ${data.errorType ?? ""}<br><br>
      <strong>Closure Code:</strong> ${data.closureCode ?? ""}<br><br>
      <strong>Solution:</strong> ${data.solution ?? ""}</p><br><br>
      <strong>Comment:</strong> ${comment ?? ""}</p>
      <p>
            <p>Regards,<br><br></p>

         <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View Incident Details
              </a>
      </p>

    <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(data.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
    </div>
  `,
        }),
      });
      //console.log("Email sent successfully!");
    } catch (emailErr) {
      console.error("Failed to send email notification:", emailErr);
    }
  } else if (!isAdmin) {
    try {
      const emails = await fetchEmailsWithRole2();
      await authFetch(`${config.apiBaseUrl}/api/email/send`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          to: emails,
          subject: `An Incident with ID ${data.ticketId} has been Put on hold `,
          body: `
          <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
            <p>Hello,</p>
            <p>A ticket with ID ${
              data.ticketId
          } has been put on hold with the following comment</p>
                 <p><strong>Customer:</strong> ${
              data.affectedCustomer ?? ""
          }<br><br>

      <strong>Network:</strong> ${data.affectedNetwork ?? ""}<br><br>
      <strong>Site:</strong> ${data.affectedSite ?? ""}<br><br>
      <strong>Link:</strong> ${data.affectedLink ?? ""}<br><br>
<strong>Incident Start Date:</strong> ${
              data.incidentStartDatetime
                  ? data.incidentStartDatetime.replace("T", " ")
                  : ""
          }<br><br>


<strong>Incident Close Date:</strong> ${
              data.incidentCloseDatetime
                  ? data.incidentCloseDatetime.replace("T", " ")
                  : ""
          }<br><br>

      <strong>Summary:</strong> ${data.summary ?? ""}<br><br>
      <strong>Description:</strong> ${data.description ?? ""}<br><br>
      <strong>Error Type:</strong> ${data.errorType ?? ""}<br><br>
      <strong>Closure Code:</strong> ${data.closureCode ?? ""}<br><br>
      <strong>Solution:</strong> ${data.solution ?? ""}</p>
            <p>
                        <p>Regards,<br><br><br></p>

              <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View Incident Details
              </a>
            </p>
           <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(data.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
          </div>
        `,
        }),
      });
      //console.log("Email sent: Customer was NOT informed.");
    } catch (emailErr) {
      console.error("Failed to send fallback email notification:", emailErr);
    }
  }
};

export const handleReactivate = async (
    data: IncidentData,
    fetchMessages: () => void,
    onUpdate?: (updated: IncidentData) => void
) => {
  const networkInfo =
      isallnetwork === "true" ? "All Networks" : data.affectedNetwork ?? "";
  const username = localStorage.getItem("username") || "System";
  const payload = {
    username,
    message: `Incident With Id ${data.ticketId} Reactivated.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    const msgRes = await postMessage(payload);
    const updRes = await authFetch(
        `${config.apiBaseUrl}/api/incidents/${data.ticketId}/reactivate`,
        { method: "PUT" }
    );

    if (msgRes.ok && updRes.ok) {
      fetchMessages(); // refresh messages

      let updated: IncidentData;

      try {
        // try parsing response if any
        const text = await updRes.text();
        if (text) {
          updated = JSON.parse(text);
        } else {
          // fallback: fetch latest incident from backend
          const res = await fetch(
              `${config.apiBaseUrl}/api/incidents/${data.ticketId}`,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                },
              }
          );
          updated = await res.json();
        }
      } catch (err) {
        console.error("Failed to get updated incident:", err);
        updated = data; // last resort fallback
      }

      onUpdate?.(updated); // update parent grid
    } else {
      console.error("Failed to Reactivate or save message");
    }
  } catch (e) {
    console.error("Error while Reactivating incident:", e);
  }
//   if (data.customerInformed) {
//     const emails = await fetchcustomerEmails(data);

//     try {
//       await authFetch(`${config.apiBaseUrl}/api/email/send`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },

//         body: JSON.stringify({
//           to: emails,
//           subject: `An Incident with ID ${data.ticketId} has been Reactivated.`,
//           body: `
//     <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
//       <p>Hello,</p>

//    A ticket with ID ${
//      data.ticketId
//    }  has been reactivated with the following comment


//       <p><strong>Customer:</strong> ${data.affectedCustomer ?? ""}<br><br>
//       <strong>Network:</strong> ${data.affectedNetwork ?? ""}<br><br>
//       <strong>Site:</strong> ${data.affectedSite ?? ""}<br><br>
//       <strong>Link:</strong> ${data.affectedLink ?? ""}<br><br>
// <strong>Incident Start Date:</strong> ${
//             data.incidentStartDatetime
//               ? data.incidentStartDatetime.replace("T", " ")
//               : ""
//           }<br><br>


// <strong>Incident Close Date:</strong> ${
//             data.incidentCloseDatetime
//               ? data.incidentCloseDatetime.replace("T", " ")
//               : ""
//           }<br><br>
//   <strong>Summary:</strong> ${data.summary ?? ""}<br><br>
//   <strong>Description:</strong> ${data.description ?? ""}<br><br>
//   <strong>Error Type:</strong> ${data.errorType ?? ""}<br><br>
//   <strong>Closure Code:</strong> ${data.closureCode ?? ""}<br><br>
//   <strong>Solution:</strong> ${data.solution ?? ""}<br><br>
//     <p>
//           <p>Regards,<br><br></p>

//  <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
//                 👉 View Incident Details
//               </a>
//     </p>

//      <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
//       <tr>
//         <td style="vertical-align: top; padding-right: 12px;">

//          <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />


//         </td>

//         <td>
//           <div style="
//             padding: 12px;
//             border-left: 4px solid #2a1364;
//             background-color: #f9f9f9;
//             color: #2a1364;
//             font-size: 13px;
//           ">
//             <strong>Managed Services Operations</strong><br>
//             Value-Added Service<br>
//             Tel. & Whatsapp msg: +41 225521085<br>
//             Email: <a href="mailto:support@bcomintelsat.com" style="color: #2a1364;">support@bcomintelsat.com</a>
//           </div>
//         </td>
//       </tr>
//     </table>
//     </div>
//   `,
//         }),
//       });
//       //console.log("Email sent successfully!");
//     } catch (emailErr) {
//       console.error("Failed to send email notification:", emailErr);
//     }
//   } else if (!isAdmin) {
//     try {
//       const emails = await fetchEmailsWithRole2();
//       await authFetch(`${config.apiBaseUrl}/api/email/send`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           to: emails,
//           subject: `An Incident with ID ${data.ticketId}  has been  Reactivated`,
//           body: `
//           <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
//             <p>Hello,</p>
//             <p>   A ticket with ID ${
//               data.ticketId
//             }  has been reactivated with the following comment
// </p><br>
//                 <p><strong>Customer:</strong> ${
//                   data.affectedCustomer ?? ""
//                 }<br><br>
//       <strong>Network:</strong> ${data.affectedNetwork ?? ""}<br><br>
//       <strong>Site:</strong> ${data.affectedSite ?? ""}<br><br>
//       <strong>Link:</strong> ${data.affectedLink ?? ""}<br><br>
// <strong>Incident Start Date:</strong> ${
//             data.incidentStartDatetime
//               ? data.incidentStartDatetime.replace("T", " ")
//               : ""
//           }<br><br>


// <strong>Incident Close Date:</strong> ${
//             data.incidentCloseDatetime
//               ? data.incidentCloseDatetime.replace("T", " ")
//               : ""
//           }<br><br><br>

//       <strong>Summary:</strong> ${data.summary ?? ""}<br><br>
//       <strong>Description:</strong> ${data.description ?? ""}<br><br>
//       <strong>Error Type:</strong> ${data.errorType ?? ""}<br><br>
//       <strong>Closure Code:</strong> ${data.closureCode ?? ""}<br><br>
//       <strong>Solution:</strong> ${data.solution ?? ""}</p><br>
//             <p>
//                         <p>Regards,<br><br><br></p>

//                <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
//                 👉 View Incident Details
//               </a>
//             </p>
//         <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
//       <tr>
//         <td style="vertical-align: top; padding-right: 12px;">

//          <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />


//         </td>

//         <td>
//           <div style="
//             padding: 12px;
//             border-left: 4px solid #2a1364;
//             background-color: #f9f9f9;
//             color: #2a1364;
//             font-size: 13px;
//           ">
//             <strong>Managed Services Operations</strong><br>
//             Value-Added Service<br>
//             Tel. & Whatsapp msg: +41 225521085<br>
//             Email: <a href="mailto:support@bcomintelsat.com" style="color: #2a1364;">support@bcomintelsat.com</a>
//           </div>
//         </td>
//       </tr>
//     </table>
//           </div>
//         `,
//         }),
//       });
//       //console.log("Email sent: Customer was NOT informed.");
//     } catch (emailErr) {
//       console.error("Failed to send fallback email notification:", emailErr);
//     }
//   }
};

export const handleReopen = async (
    data: IncidentData,
    fetchMessages: () => void,
    onUpdate?: (updated: IncidentData) => void
) => {
  const username = localStorage.getItem("username") || "System";
  const payload = {
    username,
    message: `Incident With Id ${data.ticketId} Reopened.`,
    date: new Date().toISOString(),
    read: false,
    ticketId: data.ticketId,
  };

  try {
    const msgRes = await postMessage(payload);
    const updRes = await authFetch(
        `${config.apiBaseUrl}/api/incidents/${data.ticketId}/reopen`,
        { method: "PUT" }
    );

    if (msgRes.ok && updRes.ok) {
      fetchMessages(); // refresh messages

      let updated: IncidentData;

      try {
        // try parsing response if any
        const text = await updRes.text();
        if (text) {
          updated = JSON.parse(text);
        } else {
          // fallback: fetch latest incident from backend
          const res = await fetch(
              `${config.apiBaseUrl}/api/incidents/${data.ticketId}`,
              {
                headers: {
                  Authorization: `Bearer ${localStorage.getItem("authToken")}`,
                },
              }
          );
          updated = await res.json();
        }
      } catch (err) {
        console.error("Failed to get updated incident:", err);
        updated = data; // last resort fallback
      }

      onUpdate?.(updated); // update parent grid
    } else {
      console.error("Failed to Reactivate or save message");
    }
  } catch (e) {
    console.error("Error while Reactivating incident:", e);
  }
//   if (data.customerInformed) {
//     const emails = await fetchcustomerEmails(data);

//     try {
//       await authFetch(`${config.apiBaseUrl}/api/email/send`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },

//         body: JSON.stringify({
//           to: emails,
//           subject: `An Incident with ID ${data.ticketId}  has been Reopened`,
//           body: `
//     <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
//       <p>Hello,</p>

//       <p>This Ticket was Reopened with following comment:</p>

//       <p><strong>Customer:</strong> ${data.affectedCustomer ?? ""}<br><br>
//       <strong>Network:</strong> ${data.affectedNetwork ?? ""}<br><br>
//       <strong>Site:</strong> ${data.affectedSite ?? ""}<br><br>
//       <strong>Link:</strong> ${data.affectedLink ?? ""}<br><br>
// <strong>Incident Start Date:</strong> ${
//             data.incidentStartDatetime
//               ? data.incidentStartDatetime.replace("T", " ")
//               : ""
//           }<br><br>


// <strong>Incident Close Date:</strong> ${
//             data.incidentCloseDatetime
//               ? data.incidentCloseDatetime.replace("T", " ")
//               : ""
//           }<br><br>

//       <strong>Summary:</strong> ${data.summary ?? ""}<br><br>
//       <strong>Description:</strong> ${data.description ?? ""}<br><br>
//       <strong>Error Type:</strong> ${data.errorType ?? ""}<br><br>
//       <strong>Closure Code:</strong> ${data.closureCode ?? ""}<br><br>
//       <strong>Solution:</strong> ${data.solution ?? ""}</p>
//       <p>
//             <p>Regards,<br><br><br></p>

//      <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
//                 👉 View Incident Details
//               </a>
//       </p>

//     <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
//       <tr>
//         <td style="vertical-align: top; padding-right: 12px;">

//          <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />


//         </td>

//         <td>
//           <div style="
//             padding: 12px;
//             border-left: 4px solid #2a1364;
//             background-color: #f9f9f9;
//             color: #2a1364;
//             font-size: 13px;
//           ">
//             <strong>Managed Services Operations</strong><br>
//             Value-Added Service<br>
//             Tel. & Whatsapp msg: +41 225521085<br>
//             Email: <a href="mailto:support@bcomintelsat.com" style="color: #2a1364;">support@bcomintelsat.com</a>
//           </div>
//         </td>
//       </tr>
//     </table>
//     </div>
//   `,
//         }),
//       });
//       // alert(recipients);
//     } catch (emailErr) {
//       console.error("Failed to send email notification:", emailErr);
//     }
//   } else if (!isAdmin) {
//     try {
//       const emails = await fetchEmailsWithRole2();
//       await authFetch(`${config.apiBaseUrl}/api/email/send`, {
//         method: "POST",
//         headers: {
//           "Content-Type": "application/json",
//         },
//         body: JSON.stringify({
//           to: emails,
//           subject: `An Incident with ID ${data.ticketId} has been Reopened`,
//           body: `
//           <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
//             <p>Hello,</p>
//            <p>This Ticket was Reopened with following comment:</p>
//                  <p><strong>Customer:</strong> ${
//                    data.affectedCustomer ?? ""
//                  }<br><br>
//       <strong>Network:</strong> ${data.affectedNetwork ?? ""}<br><br>
//       <strong>Site:</strong> ${data.affectedSite ?? ""}<br><br>
//       <strong>Link:</strong> ${data.affectedLink ?? ""}<br><br>
// <strong>Incident Start Date:</strong> ${
//             data.incidentStartDatetime
//               ? data.incidentStartDatetime.replace("T", " ")
//               : ""
//           }<br><br>


// <strong>Incident Close Date:</strong> ${
//             data.incidentCloseDatetime
//               ? data.incidentCloseDatetime.replace("T", " ")
//               : ""
//           }<br><br>

//       <strong>Summary:</strong> ${data.summary ?? ""}<br><br>
//       <strong>Description:</strong> ${data.description ?? ""}<br><br>
//       <strong>Error Type:</strong> ${data.errorType ?? ""}<br><br>
//       <strong>Closure Code:</strong> ${data.closureCode ?? ""}<br><br>
//       <strong>Solution:</strong> ${data.solution ?? ""}</p>
//             <p>
//             <p>Regards,<br><br><br><br></p>
//               <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
//                 👉 View Incident Details
//               </a>
//             </p>

//             <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
//       <tr>
//         <td style="vertical-align: top; padding-right: 12px;">

//          <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />


//         </td>

//         <td>
//           <div style="
//             padding: 12px;
//             border-left: 4px solid #2a1364;
//             background-color: #f9f9f9;
//             color: #2a1364;
//             font-size: 13px;
//           ">
//             <strong>Managed Services Operations</strong><br>
//             Value-Added Service<br>
//             Tel. & Whatsapp msg: +41 225521085<br>
//             Email: <a href="mailto:support@bcomintelsat.com" style="color: #2a1364;">support@bcomintelsat.com</a>
//           </div>
//         </td>
//       </tr>
//     </table>
//           </div>
//         `,
//         }),
//       });
//       //console.log("Email sent: Customer was NOT informed.");
//     } catch (emailErr) {
//       console.error("Failed to send fallback email notification:", emailErr);
//     }
//   }
};
